import styled from 'styled-components';

import { flexbox, alignItems, justifyContent } from '@styles/helpers/flexbox';

import ThemeHelper from '@themes/theme-helper';

export const Root = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('center')};
  min-width: 0;
`;

export const Text = styled.span((props) => {
  const { width = '20%', alignHorizontal = 'center' } = props;

  return `
    ${flexbox()};
    ${alignItems('center')};
    ${justifyContent(alignHorizontal)};
    padding: 3px 8px;
    margin: 0px 5px;
    width: ${width};
    font-size: 14px;
    overflow: hidden;
  `;
});

export const DueDate = styled.span((props) => {
  const { width = '20%', alignHorizontal = 'center', currentAssignmentUnavailableForStudent } = props;

  let color = '#4e5c67'
  let backgroundColor = '#fff'
  if (currentAssignmentUnavailableForStudent) {
    color = '#C51B29'
    backgroundColor = '#FDEEEF'
  }

  return `
    ${flexbox()};
    ${alignItems('center')};
    ${justifyContent(alignHorizontal)};
    padding: 3px 8px;
    margin: 0px 5px;
    width: ${width};
    font-size: 14px;
    overflow: hidden;
	color: ${color}
	background-color: ${backgroundColor};
	border-radius: 20px;
  `;;
});

export const EllipsisText = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const CheckboxWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
      padding: 2px 8px;
      margin: 0px 5px;

      div {
        border: 1px solid ${colours.grey[200]};
        border-radius: 2px;
      }
  `;
});